module.exports = __webpack_public_path__ + "img/Niktmi_sie_nie_oprze_tn.0c4c322d.jpg";